import ErrorBoundary from './error-boundary';
import { RouteBoundary } from './route-boundary';
import { useCatchError } from './use-catch-error';

export default ErrorBoundary;

export {
  RouteBoundary,
  useCatchError,
};
